import type { HTMLAttributes } from 'react';
import { Badge as DsBadge } from '@repo/design-system/components/ui/v2/badge';
import { cn } from '../../lib/utils.ts';

/**
 * The CRM's Badge: the design system's v2 Badge (TS-1681), copied from Hriq. The design system
 * names its badges by colour; the CRM's pages name them by meaning, so this maps one onto the
 * other. Every colour is the design system's own (badge.tokens.css), except `caution`: the
 * design system has no yellow, so it is the CRM's (`--crm-caution-*` in styles/tokens.css).
 */
const COLOR = {
  default: 'purple',
  brand: 'purple',
  secondary: 'gray',
  outline: 'darkGray',
  success: 'green',
  warning: 'orange',
  danger: 'red',
  caution: 'gray',
} as const;

const CAUTION = 'bg-(--crm-caution-bg) text-(--crm-caution-fg)';

export type BadgeVariant = keyof typeof COLOR;

export function Badge({
  variant = 'default',
  className,
  ...props
}: Omit<HTMLAttributes<HTMLSpanElement>, 'color'> & { variant?: BadgeVariant | null }) {
  return (
    <DsBadge
      color={COLOR[variant ?? 'default']}
      size="sm"
      className={cn(variant === 'caution' && CAUTION, className)}
      {...props}
    />
  );
}
